import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { fetchIp, trackPurchase } from "../../../../components/commonClass/CommonFunctions";
import { getAllData, postDownloadVoucher, postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import { loaderActions } from "../../../../_actions/loader.actions";
import { updateActions } from "../../../../_actions/user.action";
import { ClearLocalStorage, GetLocalStorage } from "../../../../components/commonClass/Session";
import { decryptUrlDatapattern } from "../../../../components/commonClass/EncFunc";
import { AirDataObjects } from "../../ProccedBooking/Flights/FlightSeatsEnum";
import { Modal } from "react-bootstrap";
import FlightCancellation from "./partial/FlightCancellation";


const FlightBookingConfirmation = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [flightModel, setFlightModel] = useState(false)
    const [flightBookingData, setFlightBookingData] = useState<any>({
        flightDetails: null,
        bookingDetails: null,
        Messages: null
    });
    const [flightData, setFlightData] = useState(null);
    const [cancelletionMessage, setCancellationMessage] = useState<any>(null);

    const isDomeRtnData = sessionStorage.getItem('isDomRtn');
    const isDomRtn = isDomeRtnData ? JSON.parse(isDomeRtnData) : 0;

    const isinternationalData = sessionStorage.getItem('isinternational');
    const isInternational = isinternationalData ? JSON.parse(isinternationalData) : false;

    const [flightSegment, setFlightSegment] = useState([])
    const isUpdate = useSelector((store: any) => store?.update?.isUpdate)

    //#region get passengers price and counts
    const passangerPriceBU = useMemo(() => {

        let adultCount, childCount, infantCount, adultPrice, childPrice, infantPrice = 0;
        if (flightBookingData?.Messages?.[0]?.ResponseType === 1) {
            adultCount = flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.filter((fin: any) => fin?.paxType?.toString() === "1")?.length || 0;
            childCount = flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.filter((fin: any) => fin?.paxType?.toString() === "2")?.length || 0;
            infantCount = flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.filter((fin: any) => fin?.paxType?.toString() === "3")?.length || 0;

            adultPrice = flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.filter((fin: any) => fin?.paxType?.toString() === "1")?.reduce((acc: any, curr: any) => (
                acc = acc + curr?.fare?.baseFare
            ), 0);
            childPrice = flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.filter((fin: any) => fin?.paxType?.toString() === "2")?.reduce((acc: any, curr: any) => (
                acc = acc + curr?.fare?.baseFare
            ), 0);
            infantPrice = flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.filter((fin: any) => fin?.paxType?.toString() === "3")?.reduce((acc: any, curr: any) => (
                acc = acc + curr?.fare?.baseFare
            ), 0);
            if (flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.grandTotal && sessionStorage?.getItem("isFlightPurchase") === 'false') {
                trackPurchase(flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.grandTotal)
            }
        }
        else {
            adultCount = flightBookingData?.flightDetails?.adultsCount
            childCount = flightBookingData?.flightDetails?.childCount
            infantCount = flightBookingData?.flightDetails?.infantCount

            adultPrice = flightBookingData?.flightDetails?.fareBreakDown?.find((fin: any) => fin?.passengerType?.toString() === "1")?.baseFare
            childPrice = flightBookingData?.flightDetails?.fareBreakDown?.find((fin: any) => fin?.passengerType?.toString() === "2")?.baseFare
            infantPrice = flightBookingData?.flightDetails?.fareBreakDown?.find((fin: any) => fin?.passengerType?.toString() === "3")?.baseFare
        }


        return {
            adultCount: adultCount,
            childCount: childCount,
            infantCount: infantCount,
            total: adultCount + childCount + infantCount,
            adultPrice: adultPrice,
            childPrice: childPrice,
            infantPrice: infantPrice,
        }
    }, [flightBookingData])
    //#endregion

    const [searchParams, setSearchParams] = useSearchParams();
    const leadPassenger = useMemo(() => {
        if (flightBookingData?.Messages?.[0]?.ResponseType === 1) {
            return flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.find((fin: any) => fin?.isLeadPax === true)
        }
        else {
            return flightBookingData?.flightDetails?.passenger?.find((fin: any) => fin?.isLeadPax === true)
        }
    }, [flightBookingData?.flightDetails])

    const APIBadMessage = 'Something went wrong, Please try again!'

    useEffect(() => {
        if (localStorage.getItem('last') !== null && localStorage.getItem('last') === "true") {
            window.history.forward()
        }
    }, [])

    const getPaxType = (type: number) => {
        switch (type) {
            case 1: return 'Adult';
            case 2: return 'Child';
            case 3: return 'Infant';
            default: return '-';
        }
    }

    const getflightbookingdetails = async (data: any) => {
        let flightpaymentresponse: any = { status: true };
        let bookingcodebybookingid: any = { status: true };
        let flightbookingdetails: any = { status: true };

        flightpaymentresponse = await postUsersData('/customerui/v1/getflightpaymentresponse', {
            BookingId: data?.BookingId,
            ResponseType: data?.ResponseType,
            PaymentId: data?.PaymentId,
            UserId: data?.UserId,
            BookingStatus: location?.state?.BookingStatus || 0
        })
        if (flightpaymentresponse?.status) {
            isDomRtn === 1 && sessionStorage?.setItem('rfd', "null")
            setFlightBookingData((prev: any) => ({ ...prev, Messages: flightpaymentresponse?.data }));

            bookingcodebybookingid = await getAllData(`/customerui/v1/getbookingcodebybookingid?bookingId=${data?.BookingId}`)
            if (bookingcodebybookingid?.status) {
                let cloneSegment: any = [...bookingcodebybookingid?.data?.[0]?.requestSegmentList]

                bookingcodebybookingid?.data?.[0]?.requestSegmentList.reduce((acc: any, sector: any) => {
                    if (sector.returnDate) {
                        let obj = {
                            flightRequestSegmentId: 885,
                            origin: sector?.destination,
                            destination: sector?.origin,
                            departureDate: sector?.returnDate,
                            returnDate: null
                        }
                        cloneSegment = [...cloneSegment, obj]
                    }
                    return
                }, [])
                setFlightSegment(cloneSegment)
                setFlightBookingData((prev: any) => ({ ...prev, bookingDetails: bookingcodebybookingid?.data }));

                if (flightpaymentresponse?.data?.[0]?.ResponseType === 1) {
                    flightbookingdetails = await postUsersData('/customerui/v1/getflightbookingdetails', {
                        EndUserIp: data?.EndUserIp,
                        pnr: data?.flightPNR,
                        bookingId: data?.flightBookingId
                    })
                    if (flightbookingdetails?.status) {
                        setFlightData(flightbookingdetails?.data || null);
                        setFlightBookingData((prev: any) => ({ ...prev, flightDetails: flightbookingdetails?.data }));
                    }
                }
                else {
                    flightbookingdetails = await getAllData(`/customerui/v1/getinternalflightdetailsbyid?bookingId=${data?.BookingId}`)
                    if (flightbookingdetails?.status) {
                        setFlightBookingData((prev: any) => ({ ...prev, flightDetails: flightbookingdetails?.data?.[0] }));
                    }
                }
            }
        }

        let apiCollections = [flightpaymentresponse, bookingcodebybookingid, flightbookingdetails];
        let falseStatus = apiCollections?.find((ele) => !ele?.status)
        if (falseStatus) {
            dispatch({ type: 'ALERTING', message: falseStatus?.message || APIBadMessage });
            dispatch(loaderActions.end());
        }

    }

    const flightbookingdetailsAPI = async () => {
        const userip = await fetchIp();
        const flightbookingdetails = await postUsersData('/customerui/v1/getflightbookingdetails', {
            EndUserIp: userip?.data,
            pnr: location?.state?.flightPNR || "",
            bookingId: location?.state?.flightBookingId || 0
        })
        if (flightbookingdetails?.status) {
            setFlightData(flightbookingdetails?.data || null);
        }
        dispatch(updateActions.updatedclear());
    }

    useEffect(() => {
        if (isUpdate) {
            flightbookingdetailsAPI();
        }
    }, [isUpdate])

    const RedirectToFllightListScreen = () => {
        const params = new URLSearchParams(searchParams);
        params.delete("tId");
        params.delete("rIndex");

        return '/flights/search?' + params.toString();
    }

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                if (location?.state !== null) {
                    const user: any = GetLocalStorage();
                    const userip = await fetchIp();
                    const fltbookid = decryptUrlDatapattern(location?.state?.BookingId)?.[isDomRtn];
                    if (userip?.status) {
                        const data = {
                            EndUserIp: userip?.data,
                            flightPNR: location?.state?.flightPNR,
                            flightBookingId: location?.state?.flightBookingId,
                            BookingId: fltbookid,
                            ResponseType: location?.state?.ResponseType,
                            PaymentId: location?.state?.PaymentId,
                            UserId: user?.userMasterID
                        }
                        dispatch(loaderActions.start());
                        await Promise.all([
                            getflightbookingdetails(data),
                        ])
                        localStorage.setItem("last", "true")
                        localStorage.setItem("isOpenDup", "false")
                        dispatch(loaderActions.end());
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', path: RedirectToFllightListScreen() });
                    }
                }
                else {
                    dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', path: RedirectToFllightListScreen() });
                }
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
        fetchData();
    }, [])

    const dateFormat = (date: any) => {
        let d = new Date(date);
        let day = d?.toLocaleString("en-US", { day: '2-digit' });
        let month = d?.toLocaleString("en-US", { month: 'short' });
        let year = d?.toLocaleString("en-US", { year: 'numeric' });
        return date ? `${day} ${month} ${year}` : null;
    }

    const flightDateFormat = (date: any) => {
        const d = new Date(date);
        const weekday = d?.toLocaleString("en-US", { weekday: 'short' });
        const day = d?.toLocaleString("en-US", { day: 'numeric' });
        const month = d?.toLocaleString("en-US", { month: 'short' });
        const year = d?.toLocaleString("en-US", { year: 'numeric' });
        let hours = d?.getHours();
        const minute = d?.getMinutes()?.toString()?.padStart(2, '0')
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 === 0 ? 12 : hours % 12;
        return date ? `${weekday},${day} ${month} ${year} ${hours?.toString()?.padStart(2, '0')}:${minute} ${ampm}` : null;
    }

    const handleBack = (e: any) => {
        e.preventDefault();
        navigate(RedirectToFllightListScreen());
    }

    function convertDurationToHM(duration: any, istotal: boolean) {
        if (istotal) {
            const layoverTimes = [];
            for (let i = 0; i < duration?.length - 1; i++) {
                const arrivalTime: any = new Date(duration[i].arrTime);
                const nextDepartureTime: any = new Date(duration[i + 1].depTime);
                const layoverDuration = nextDepartureTime - arrivalTime;
                if (layoverDuration > 0) {
                    const totalMinutes = Math.floor(layoverDuration / (1000 * 60));
                    layoverTimes?.push({
                        layover: totalMinutes,
                    });
                }
            }
            const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
            const totallayover = layoverTimes?.reduce((sum, flight) => sum + flight?.layover, 0);
            const hours = Math?.floor((totalDuration + totallayover) / 60);
            const minutes = (totalDuration + totallayover) % 60;
            return `${hours?.toString()?.length > 1 ? hours : `0${hours}`}: ${minutes?.toString()?.length > 1 ? minutes : `0${minutes}`} Hrs`;
        }
        else {
            const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
            const hours = Math?.floor((totalDuration) / 60);
            const minutes = totalDuration % 60;
            return `${hours?.toString()?.length > 1 ? hours : `0${hours}`}: ${minutes?.toString()?.length > 1 ? minutes : `0${minutes}`} Hrs`;
        }
    }

    //#region flight booking voucher
    const [vaddress, setvAddress] = useState([])

    const getvoucheraddressdetails = async () => {
        dispatch(loaderActions.start());
        await getAllData('/customerui/v1/getvoucheraddressdetails')?.then((rep) => {
            setvAddress(rep?.data)
        })
        dispatch(loaderActions.end());
    }

    useEffect(() => {
        getvoucheraddressdetails()
    }, [])

    //#endregion flight booking voucher
    const RetryPayment = (name: string) => {
        const newSearchParams = new URLSearchParams(searchParams);
        navigate({ pathname: `/flight/` + name, search: newSearchParams.toString() }, { state: { ...location?.state, isRetryPayment: true } })
    }

    const GoBackToHomePage = () => {
        navigate(RedirectToFllightListScreen());
    }

    const getBookingLabel = (type: number) => {
        switch (type) {
            case 0: return 'Booking Failed';
            case 1: return 'Booking Confirmation';
            case 2: return 'Booking Pending';
            default: return '';
        }
    }

    //#region flight Cancellation


    const closeModal = () => {
        setFlightModel(false);
        if (cancelletionMessage !== null) {
            RedirectToFllightListScreen();
        }
    }
    //#region 

    // #region Create voucher object 

    const bookdomrtn = (name: string) => {
        const newSearchParams = new URLSearchParams(searchParams);
        sessionStorage.setItem('isDomRtn', JSON.parse("1"));
        navigate({ pathname: `/flight/` + name, search: newSearchParams.toString() }, { state: location?.state })
    }

    const generatePDF = async (id: number) => {
        const postdata = {
            BookingId: id,
            TravelCategoryId: 1
        }
        const Response = await postDownloadVoucher('/customerui/v1/getvouchertemplatebytravelcategoryid', postdata, 1);
        if (!Response?.status) {
            dispatch({ type: 'ALERTING', message: Response.message });
        }
    };

    return (
        <>
            <div className="buttonSec">
                <div className="container">
                    <div className="buttonDiv">
                        <button type='button' className='border-0 p-0' onClick={(e) => handleBack(e)}><i className="fa-solid fa-arrow-left"></i></button>
                        <div className='text-end'>
                            {
                                flightBookingData?.Messages?.[0]?.ResponseType === 1 &&
                                <>
                                    <button className="button me-1 mb-1"
                                        type='button'
                                        onClick={() => generatePDF(decryptUrlDatapattern(location?.state?.BookingId)?.[isDomRtn])}>
                                        <i className="fa-solid fa-download me-2"></i>Download</button>
                                    <button className="button"
                                        type='button'
                                        onClick={() => setFlightModel(true)}>
                                        <i className="fa-solid fa-ticket me-2"></i>Cancel Ticket</button>
                                </>}
                        </div>
                    </div>
                </div>
            </div>
            <section className='midSection confirmBookingTemp'>
                <div className='container'>
                    <div className="p_confirm">
                        {getBookingLabel(flightBookingData?.Messages?.[0]?.ResponseType)}
                    </div>
                    <div className='bookingTempHead mt-2'>
                        {/* flight ids */}
                        <div className="row">
                            <div className="col-md-6 col-lg-9">
                                {(flightBookingData?.flightDetails?.response?.flightItinerary?.isDomestic
                                    && flightBookingData?.flightDetails?.response?.flightItinerary?.journeyType === 2 &&
                                    isDomRtn === 0) && <button className="book-return-flight" type='button' onClick={() => bookdomrtn('review')}>Book Return Ticket<i className="fa-solid fa-plane"></i></button>}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <div className="headRight mb-2">
                                    <table
                                        style={{ width: '100%', textAlign: 'right' }}
                                    >
                                        <tbody><tr>
                                            <td><b>ETM Ref No :</b></td>
                                            <td>{flightBookingData?.bookingDetails?.[0]?.BookingNo || flightBookingData?.bookingDetails?.[0]?.bookingNo}</td>
                                        </tr>
                                            <tr>
                                                <td><b>Booking Date :</b></td>
                                                <td>{dateFormat(flightBookingData?.bookingDetails?.[0]?.BookingDate || flightBookingData?.bookingDetails?.[0]?.bookingDate)} </td>
                                            </tr>
                                        </tbody></table>
                                </div>
                            </div>
                        </div>

                        {/* Confirmation status with text */}
                        {/* Success */}
                        {
                            flightBookingData?.Messages?.[0]?.ResponseType === 1 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-success">
                                        <i className="fa-solid fa-check"></i>
                                        <p>{flightBookingData?.Messages?.[0]?.TransMessage1?.replace('#Username', `${leadPassenger?.firstName}!`)}</p>
                                        <h3>{flightBookingData?.Messages?.[0]?.TransMessage2}</h3>
                                    </div>
                                    <div className="success-alert-msg">
                                        <p>{flightBookingData?.Messages?.[0]?.TransMessage3}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* Success */}

                        {/* Failure */}
                        {
                            flightBookingData?.Messages?.[0]?.ResponseType === 0 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-failed">
                                        <i className="fa-solid fa-xmark"></i>
                                        <h3>{flightBookingData?.Messages?.[0]?.TransMessage1}</h3>
                                    </div>
                                    <div className="failed-alert-msg">
                                        <p>{flightBookingData?.Messages?.[0]?.TransMessage3}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* Failure */}

                        {/* In Progress */}
                        {
                            flightBookingData?.Messages?.[0]?.ResponseType === 2 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-inprogress">
                                        <i className="fa-solid fa-check"></i>
                                        <p>{flightBookingData?.Messages?.[0]?.TransMessage1?.replace('#Username', `${leadPassenger?.firstName}!`)}</p>
                                        <h3>{flightBookingData?.Messages?.[0]?.TransMessage3}</h3>
                                    </div>
                                    <div className="inprogress-alert-msg">
                                        <p>{flightBookingData?.Messages?.[0]?.TransMessage4}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* In Progress */}

                        <div className="row">
                            {/* Flight Details */}
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5>Flight Details</h5>
                                    </div>
                                    {flightBookingData?.Messages?.[0]?.ResponseType === 1 &&
                                        <div className="col-md-6">
                                            <div className="mb-2">
                                                <table style={{ float: 'right', marginBottom: '8px' }}>
                                                    <tbody>
                                                        <tr>
                                                            {(!isInternational && flightBookingData?.flightDetails?.response?.flightItinerary?.journeyType === 2) &&
                                                                <td><span className='me-3' style={{ color: '#239EFE' }}><b>{isDomRtn === 0 ? "Outbound" : "Inbound"}</b>&nbsp;<i className="fa-solid fa-plane"></i></span></td>}
                                                            <td><b>PNR Number&nbsp;:&nbsp;</b>{flightBookingData?.flightDetails?.response?.flightItinerary?.pnr}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>}
                                </div>
                                <div className='overflow-auto booking_confirmation'>
                                    <table className="bookingStatusTable" style={{ wordBreak: 'break-all' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: "105px" }}>Flight</th>
                                                <th style={{ minWidth: "100px" }}>Departing</th>
                                                <th style={{ minWidth: "100px" }}></th>
                                                <th style={{ minWidth: "100px" }}>Arriving</th>
                                            </tr>
                                        </thead>
                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.segments?.map((segment: any, index: number) => {
                                                    return (
                                                        <React.Fragment key={`segment${index + 1}`}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <h5>{segment?.airline?.airlineName}</h5>
                                                                        <p>{segment?.airline?.airlineCode}&nbsp;-&nbsp;{segment?.airline?.flightNumber}</p>
                                                                        <p>Cabin&nbsp;:&nbsp;{AirDataObjects?.CabinType[segment?.cabinClass]}</p>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <div>{segment?.origin?.airport?.cityName}&nbsp;({segment?.origin?.airport?.cityCode})</div>
                                                                            </div>
                                                                            <div>{segment?.origin?.airport?.airportName}</div>
                                                                            <div className='fs-5 fw-500'>{flightDateFormat(segment?.origin?.depTime)}</div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <h5>
                                                                            <div className='fs-6 fw-500'>
                                                                                {convertDurationToHM([{
                                                                                    duration: segment?.duration,
                                                                                    depTime: segment?.origin?.depTime,
                                                                                    arrTime: segment?.destination?.arrTime
                                                                                }], false)}
                                                                            </div>
                                                                        </h5>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <div>{segment?.destination?.airport?.cityName}&nbsp;({segment?.destination?.airport?.cityCode})</div>
                                                                            <div>{segment?.destination?.airport?.airportName}</div>
                                                                            <div className='fs-5 fw-500'>{flightDateFormat(segment?.destination?.arrTime)}</div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={4}>
                                                                        <span>Baggage CHECKIN<b>&nbsp;{segment?.baggage}</b></span>
                                                                        &nbsp;&nbsp;<span>CABIN <b>&nbsp;{segment?.cabinBaggage}</b></span></td>
                                                                </tr>
                                                            </tbody>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                flightBookingData?.flightDetails?.segments?.map((segment: any, index: number) => {
                                                    return (
                                                        <React.Fragment key={`segment${index + 1}`}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <h5>{segment?.airlineName}</h5>
                                                                        <p>{segment?.airlineCode}&nbsp;-&nbsp;{segment?.flightNumber}</p>
                                                                        <p>Cabin&nbsp;:&nbsp;{AirDataObjects?.CabinType[flightBookingData?.flightDetails?.cabinClass]}</p>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <div>{segment?.originCityName}&nbsp;{segment?.originCityCode}</div>
                                                                            </div>
                                                                            <div>{segment?.originAirportName}</div>
                                                                            <div className='fs-5 fw-500'>{flightDateFormat(segment?.originDepTime)}</div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <h5>
                                                                            <div className='fs-6 fw-500'>
                                                                                {convertDurationToHM([{
                                                                                    duration: segment?.duration || 0,
                                                                                    depTime: segment?.originDepTime,
                                                                                    arrTime: segment?.destinationArrTime
                                                                                }], false)}
                                                                            </div>
                                                                        </h5>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <div>{segment?.destinationCityName}&nbsp;{segment?.destinationCityCode}</div>
                                                                            <div>{segment?.destinationAirportName}</div>
                                                                            <div className='fs-5 fw-500'>{flightDateFormat(segment?.destinationArrTime)}</div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={4}>
                                                                        <span>Baggage CHECKIN<b>&nbsp;{segment?.baggage}</b></span>
                                                                        &nbsp;&nbsp;<span>CABIN<b>&nbsp;{segment?.cabinBaggage}</b></span></td>
                                                                </tr>
                                                            </tbody>
                                                        </React.Fragment>
                                                    )
                                                }
                                                )
                                        }

                                    </table>
                                </div>
                            </div>
                            {/* Guest Information */}
                            <div className="col-lg-12">
                                <h5>Guest Information</h5>
                                <div className='overflow-auto booking_confirmation'>
                                    <table className="bookingStatusTable tr-bg" style={{ wordBreak: 'break-all' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: "50px" }}>Sq. No.</th>
                                                <th style={{ minWidth: "200px" }}>Name</th>
                                                <th style={{ minWidth: "75px" }}>Type</th>
                                                {
                                                    flightBookingData?.Messages?.[0]?.ResponseType === 1 &&
                                                    <th style={{ minWidth: "130px" }}>E-Ticket Number</th>
                                                }
                                                <th style={{ minWidth: "110px" }}>Phone</th>
                                                <th style={{ minWidth: "110px" }}>Email ID</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                    flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.map((pass: any, index: number) => {
                                                        return (
                                                            <React.Fragment key={`${pass?.paxId}${index + 1}`}>
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{(!pass?.title && !pass?.firstName && !pass?.lastName) ? '-' : `${pass?.title} ${pass?.firstName} ${pass?.lastName}`}</td>
                                                                    <td>{getPaxType(pass?.paxType)}</td>
                                                                    <td>{pass?.ticket?.ticketNumber || '-'}</td>
                                                                    <td>{pass?.contactNo || '-'}</td>
                                                                    <td>{pass?.email ? <a href={`mailto:${pass?.email}`}> {pass?.email} </a> : '-'}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={6}>
                                                                        <div className="row mx-2">
                                                                            <div className="col-sm-6 col-12">
                                                                                <div className='fw-500'><span className='me-2'>Add-On</span>
                                                                                    <span className='mx-2 fw-500'>Extra Baggage&nbsp;:&nbsp;<span className='fw-bold'>{pass?.baggage?.map((bag: any) => `${bag?.weight}Kgs`)?.join(', ')}</span></span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-6 col-12">
                                                                                <div className='fw-500'>MEALS&nbsp;:&nbsp;<span className='fw-bold'>{pass?.mealDynamic?.map((meal: any) => meal?.airlineDescription)?.join(', ')}</span></div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                    :
                                                    flightBookingData?.flightDetails?.passenger?.map((pass: any, index: number) => {
                                                        return (
                                                            <React.Fragment key={`${index + 1}`}>
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{(!pass?.title && !pass?.firstName && !pass?.lastName) ? '-' : `${pass?.title} ${pass?.firstName} ${pass?.lastName}`}</td>
                                                                    <td>{getPaxType(Number(pass?.paxType))}</td>
                                                                    {
                                                                        flightBookingData?.Messages?.[0]?.ResponseType === 1 &&
                                                                        <td>{pass?.ticket?.ticketNumber || '-'}</td>
                                                                    }
                                                                    <td>{pass?.contactNo || '-'}</td>
                                                                    <td>{pass?.email ? <a href={`mailto:${pass?.email}`}> {pass?.email} </a> : '-'}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={6}>
                                                                        <div className="row mx-2">
                                                                            <div className="col-sm-6 col-12">
                                                                                <div className='fw-500'><span className='me-2'>Add-On</span>
                                                                                    <span className='mx-2 fw-500'>Extra Baggage&nbsp;:&nbsp;<span className='fw-bold'>{pass?.baggage?.map((bag: any) => `${bag?.weight}Kgs`)?.join(', ')}</span></span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-6 col-12">
                                                                                <div className='fw-500'>MEALS&nbsp;:&nbsp;<span className='fw-bold'>{pass?.mealDynamic?.map((meal: any) => meal?.airlineDescription)?.join(', ')}</span></div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* Total Price Breakup */}
                            <div className="col-md-12 mb-4">
                                <h5 className="mb-2">Total Price Breakup</h5>
                                <div className="price-details">
                                    <ul>
                                        {
                                            passangerPriceBU?.adultCount > 0 &&
                                            <li className='border-bottom border-4'>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="title"> Adult x {passangerPriceBU?.adultCount} </div>
                                                    <div className="value" >
                                                        ₹{passangerPriceBU?.adultPrice}
                                                    </div>
                                                </div>
                                            </li>
                                        }

                                        {
                                            passangerPriceBU?.childCount > 0 &&
                                            <li className='border-bottom border-4'>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="title"> Child x {passangerPriceBU?.childCount} </div>
                                                    <div className="value" >
                                                        ₹{passangerPriceBU?.childPrice}
                                                    </div>
                                                </div>
                                            </li>
                                        }

                                        {
                                            passangerPriceBU?.infantCount > 0 &&
                                            <li className='border-bottom border-4'>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="title"> Infant x {passangerPriceBU?.infantCount} </div>
                                                    <div className="value" >
                                                        ₹{passangerPriceBU?.infantPrice}
                                                    </div>
                                                </div>
                                            </li>
                                        }

                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalBaggageCharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Baggage Charges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalBaggageCharges}
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                flightBookingData?.flightDetails?.flightFareModel?.[0]?.totalBaggageCharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Baggage Charges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.flightFareModel?.[0]?.totalBaggageCharges}
                                                        </div>
                                                    </div>
                                                </li>

                                        }

                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalMealCharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Meal Charges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalMealCharges}
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                flightBookingData?.flightDetails?.flightFareModel?.[0]?.totalMealCharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Meal Charges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.flightFareModel?.[0]?.totalMealCharges}
                                                        </div>
                                                    </div>
                                                </li>
                                        }

                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalSeatCharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Seat Charges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalSeatCharges}
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                flightBookingData?.flightDetails?.flightFareModel?.[0]?.totalSeatCharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Seat Charges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.flightFareModel?.[0]?.totalSeatCharges}
                                                        </div>
                                                    </div>
                                                </li>
                                        }

                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalTaxAndSurcharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Taxes and Surcharges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.totalTaxAndSurcharges}
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                flightBookingData?.flightDetails?.totalTaxAndSurcharges > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Taxes and Surcharges + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.totalTaxAndSurcharges}
                                                        </div>
                                                    </div>
                                                </li>
                                        }

                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.convinienceFee > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Convinience fees charged + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.convinienceFee}
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                flightBookingData?.flightDetails?.convinienceFee > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Convinience fees charged + </div>
                                                        <div className="value" >
                                                            ₹{flightBookingData?.flightDetails?.convinienceFee}
                                                        </div>
                                                    </div>
                                                </li>
                                        }

                                        {
                                            flightBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.grandTotal > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Grand Total </div>
                                                        <div className="value" style={{ color: 'red' }} >
                                                            ₹{flightBookingData?.flightDetails?.response?.flightItinerary?.fare?.grandTotal}
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                flightBookingData?.flightDetails?.grandTotal > 0 &&
                                                <li className='border-bottom border-4'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="title"> Grand Total </div>
                                                        <div className="value" style={{ color: 'red' }} >
                                                            ₹{flightBookingData?.flightDetails?.grandTotal}
                                                        </div>
                                                    </div>
                                                </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                            {/* Policies */}
                            {
                                flightBookingData?.flightDetails?.response?.flightItinerary?.fareRules?.length > 0 &&
                                <div className="col-md-12 mb-4">
                                    <h5 className="mb-2">Policies</h5>
                                    <div className="policy">
                                        <h5>Cancellation Policy</h5>
                                        {
                                            flightBookingData?.flightDetails?.response?.flightItinerary?.fareRules?.length > 0 &&
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fareRules?.length > 1 ?
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fareRules?.map((rules: any, index: number) => {
                                                    return (
                                                        <div key={`rule${index + 1}`} className='py-2 rulesList' >
                                                            <div className="mb-1 fw-bold"> {rules?.origin} - {rules?.destination} </div>
                                                            <div key={`rule${index + 1}`} dangerouslySetInnerHTML={{ __html: rules?.fareRuleDetail }}></div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                flightBookingData?.flightDetails?.response?.flightItinerary?.fareRules?.map((rules: any, index: number) => {
                                                    return (
                                                        <div key={`rule${index + 1}`} dangerouslySetInnerHTML={{ __html: rules?.fareRuleDetail }}></div>
                                                    )
                                                })
                                        }
                                    </div>
                                </div>
                            }
                        </div>

                        <div className='text-center w-100 pb-4'>
                            <button
                                type="button"
                                className=' btn proceedbookingBtn text-center'
                                onClick={() => GoBackToHomePage()}
                            >
                                Go back to home page
                            </button>
                            {location?.state?.ResponseType === 0 && (
                                <button
                                    type="button"
                                    className='ms-3 btn proceedbookingBtn text-center'
                                    onClick={() => RetryPayment('payment')}
                                >
                                    Retry Payment
                                </button>
                            )}
                        </div>

                        <Modal
                            show={flightModel}
                            onHide={() => closeModal()}
                            dialogClassName="modal-90w"
                            size="xl"
                            // backdrop="static"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <div className="modal-header py-2 border-0 row mx-0 mt-2 justify-content-between">
                                <div className="col-auto ps-0">
                                    <h5>Cancellation</h5>
                                </div>
                                <div className="col-auto ps-0">
                                    <button type="button"
                                        id="closemodal"
                                        className="btn-close closebtn_popup_position_gallery"
                                        onClick={() => closeModal()}>
                                    </button>
                                </div>
                            </div>
                            <div className="modal-body mb-2">
                                <FlightCancellation flightBookingData={flightBookingData} setFlightModel={setFlightModel} flightData={flightData} passangerPriceBU={passangerPriceBU} cancelletionMessage={cancelletionMessage} setCancellationMessage={setCancellationMessage} />

                            </div>
                        </Modal>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FlightBookingConfirmation
